<template>
  <div>
    <h2 class="font-bold text-gray-700">
      Historial de pagos de cuentas por pagar
    </h2>
    <MainListOfAccountsPayablePayments />
  </div>
</template>

<script>
import MainListOfAccountsPayablePayments from "@/components/Shopping/AccountsPayable/ListOfAccountsPayablePayments/MainListOfAccountsPayablePayments.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "ListOfAccountsPayablePayments",
  components: {
    MainListOfAccountsPayablePayments,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
